import React from "react"
import moment from "moment"

export default class LocalEventForm extends React.Component {
  constructor(props) {
    super(props);

    this.textField = this.textField.bind(this);
    this.textArea = this.textArea.bind(this);
    this.dateField = this.dateField.bind(this);
    this.timeField = this.timeField.bind(this);
    this.checkBox = this.checkBox.bind(this);

    this.handleEventUpdate = this.handleEventUpdate.bind(this);
    this.clearTimeFields = this.clearTimeFields.bind(this);
    this.initializeTime = this.initializeTime.bind(this);
    this.initializeDate = this.initializeDate.bind(this);
  }

  componentDidMount() {
    this.initializeDate("start_on");
    this.initializeTime("start_at");
    this.initializeDate("end_on");
    this.initializeTime("end_at");

    if(this.props.local_event.all_day == true) {
      $(`#time_fields_container_${this.props.local_event.id}`).addClass("hidden");
    }
  }

  componentWillUnmount() {
    $(`#start_at_${this.props.local_event.id}.timepicker`).remove();
    $(`#start_at_${this.props.local_event.id}.datepicker`).remove();
    $(`#end_at_${this.props.local_event.id}.timepicker`).remove();
    $(`#end_at_${this.props.local_event.id}.datepicker`).remove();
  }

  initializeDate(field) {
    $(`#${field}_${this.props.local_event.id}.datepicker`).pickadate({
      format: 'yyyy-mm-dd',
      onClose: () => this.handleEventUpdate(field, $(`#${field}_${this.props.local_event.id}.datepicker`)[0].value)
    });
  }

  initializeTime(field) {
    $(`#${field}_${this.props.local_event.id}.timepicker`).pickatime({
      twelvehour: true,
      afterDone: () => this.handleEventUpdate(field, $(`#${field}_${this.props.local_event.id}.timepicker`)[0].value)
    });
  }

  clearTimeFields(checked) {
    if(checked == true) {
      $(`#start_at_${this.props.local_event.id}`)[0].value = null;
      $(`#end_at_${this.props.local_event.id}`)[0].value = null;
      $(`#time_fields_container_${this.props.local_event.id}`).addClass("hidden");
      this.handleEventUpdate("start_at", "");
      this.handleEventUpdate("end_at", "");
    }
    else {
      $(`#time_fields_container_${this.props.local_event.id}`).removeClass("hidden");
    }
  }

  handleEventUpdate(field, value) {
    this.props.onEventUpdate(this.props.local_event.id, field, value);
  }

  render() {
    return (
      <div className="container">

        <div className="row px-2">
          <div className="col-12">
            {this.textField(this.props.local_event.title, "title", "Title", this.props.eventErrors["title"])}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-lg-5 col-12">
            <div className="row">
              <div className="col-5 pr-0">
                {this.dateField(this.props.local_event.start_on, "start_on", "Start Date", this.props.eventErrors["start_on"])}
              </div>
              <div className="col-2 d-flex justify-content-center pt-2">to</div>
              <div className="col-5 pl-0">
                {this.dateField(this.props.local_event.end_on, "end_on", "End Date", this.props.eventErrors["end_on"])}
              </div>
            </div>
          </div>
        </div>

        <div className="row px-2">
          <div className="col-lg-5 col-12">
            <div id={"time_fields_container_" + this.props.local_event.id} className="row">
              <div className="col-5 pr-0">
                {this.timeField(this.props.local_event.start_at, "start_at", "Start Time", this.props.eventErrors["start_at"])}
              </div>
              <div className="col-2 d-flex justify-content-center pt-2">to</div>
              <div className="col-5 pl-0">
                {this.timeField(this.props.local_event.end_at, "end_at", "End Time", this.props.eventErrors["end_at"])}
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-12">
            {this.checkBox(this.props.local_event.all_day, "all_day", "All Day")}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12">
            {this.textField(this.props.local_event.location, "location", "Location", false)}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12">
            {this.textArea(this.props.local_event.description, "description", "Description", false)}
          </div>
        </div>


        <div className="row px-2">
          <div className="col-12">
            {this.textField(this.props.local_event.more_information, "more_information", "For More Information", false)}
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <div className="row mb-2 px-3">
            <button className="btn-flat red-text cursor-pointer" data-eid={this.props.local_event.id} onClick={this.props.onDelete}>Delete Event</button>
          </div>

          <div className="row mb-2 px-3">
            <button className="btn btn-primary cursor-pointer" data-eid={this.props.local_event.id} onClick={this.props.onSave}>Save Event</button>
          </div>
        </div>
      </div>
    )
  }

  textField(fieldValue, fieldName, label, errors) {
    return (
      <div className="md-form">
        <input id={fieldName + "_" + this.props.local_event.id} className={errors ? "invalid" : ""} defaultValue={fieldValue} type="text" onChange={(e) => this.handleEventUpdate(fieldName, e.target.value)} />
        <label htmlFor={fieldName + "_" + this.props.local_event.id} className={fieldValue ? "active" : ""}>{label}</label>
      </div>
    )
  }

  textArea(fieldValue, fieldName, label, errors) {
    return (
      <div className="md-form md-textarea-container">
        <textarea className={"md-textarea materialize-textarea " + (errors ? "invalid" : "")} defaultValue={fieldValue} onChange={(e) => this.handleEventUpdate(fieldName, e.target.value)} />
        <label className={fieldValue ? "active" : ""}>{label}</label>
      </div>
    )
  }

  dateField(fieldValue, fieldName, label, errors) {
    return (
      <div className="md-form">
        <input id={fieldName + "_" + this.props.local_event.id} className={"datepicker picker__input " + (errors ? "invalid" : "")} type="text" defaultValue={fieldValue} data-field={fieldName} />
        <label htmlFor={fieldName + "_" + this.props.local_event.id} className={fieldValue ? "active" : ""}>{label}</label>
      </div>
    )
  }

  timeField(fieldValue, fieldName, label, errors) {
    return (
      <div className="md-form">
        <input id={fieldName + "_" + this.props.local_event.id} className={"timepicker " + (errors ? "invalid" : "")} type="text" data-field={fieldName}
          defaultValue={(fieldValue == null || fieldValue.length == 0) ? "" : moment(fieldValue, "YYYY-MM-DD HH:mm").format('h:mmA')} />
        <label htmlFor={fieldName + "_" + this.props.local_event.id} className={fieldValue ? "active w-100" : "w-100"}>{label}</label>
      </div>
    )
  }

  checkBox(fieldValue, fieldName, label) {
    return (
      <div className="md-form">
        <fieldset className="form-group">
            <input type="checkbox" id={fieldName + "_" + this.props.local_event.id} className="filled-in" defaultChecked={fieldValue}
              onChange={(e) => this.handleEventUpdate(fieldName, e.target.checked)} onClick={(e) => this.clearTimeFields(e.target.checked)}/>
            <label htmlFor={fieldName + "_" + this.props.local_event.id} className="w-100 h-100 pl-4 d-flex align-items-center">{label}</label>
        </fieldset>
      </div>
    )
  }
}
